//I tried lots of things. ideally, we would just extend the <select /> element and not require any changes to the markup,
//but was unable to get to this. Instead, any <select /> needs to be wrapped in an <ap-select> element.

(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').directive('apSelect', [
        ApSelect,
    ]);

    function ApSelect(
    ) {
        var directive = {
            restrict: 'E',
            transclude: true,
            templateUrl: '/core-ui/views/directives/apSelect.html',
            link: ApSelectLink,
        };

        return directive;

        function ApSelectLink(
            scope,
            element
        ) {
            // this logic is necessary to handle the fact that the chevron isn't an 'input-group-addon' anymore,
            // so in the cases where there is no other 'input-group-addon' or 'input-group-btn', we don't want to add the
            // 'input-group' class, or things will look weird
            // Because of this, I took the 'input-group' class off of the template for this directive
            var isInputGroup = element.find('.input-group-btn,.input-group-addon').length;
            if(isInputGroup) {
                var child = element.children();
                if(child) {
                    child.addClass('input-group');
                }
            }

            var $select = element.find('select');


            if (!$select.hasClass('native')) {
                addCustomDropdownChevron();
            }

            function addCustomDropdownChevron() {
                $select.parent().addClass('has-feedback');
                var icon = angular.element('<span class="form-control-feedback"><span class="ap-chevron-down-gray"></span></span>');

                $select.before(icon);
            }
        }
    }

})(window.angular);
